<template>
  <div>
    <div class="tab-container">
      <div class="tab" @click="selectedTab = 'tab1'" :class="{ active: selectedTab === 'tab1' }">
        <p v-html="$t('platformTab.tab1-title')"></p>
      </div>
      <div class="tab" @click="selectedTab = 'tab2'" :class="{ active: selectedTab === 'tab2' }">
        <p v-html="$t('platformTab.tab2-title')"></p>
      </div>
      <div class="tab" @click="selectedTab = 'tab3'" :class="{ active: selectedTab === 'tab3' }">
        <p v-html="$t('platformTab.tab3-title')"></p>
      </div>
    </div>

    <div class="tab-content" v-if="selectedTab === 'tab1'">
      <div class="image-container">
        <img src="@/assets/images/tab-image1.gif" alt="" />
      </div>
      <div class="feature-list">
        <ul>
          <li>{{ $t('platformTab.tab1-list1')}}</li>
          <li>{{ $t('platformTab.tab1-list2')}}</li>
          <li>{{ $t('platformTab.tab1-list3')}}</li>
          <li>{{ $t('platformTab.tab1-list4')}}</li>
          <li>{{ $t('platformTab.tab1-list5')}}</li>
          <li>{{ $t('platformTab.tab1-list6')}}</li>
          <li>{{ $t('platformTab.tab1-list7')}}</li>
          <router-link to="webtradingterminal" class="learn-more">Learn more</router-link>
        </ul>
      </div>
    </div>
    <div class="tab-content" v-if="selectedTab === 'tab2'">
      <div class="image-container">
        <img src="@/assets/images/tab-image2.gif" alt="" />
      </div>
      <div class="feature-list">
        <ul>
          <li>{{ $t('platformTab.tab2-list1')}}</li>
          <li>{{ $t('platformTab.tab2-list2')}}</li>
          <li>{{ $t('platformTab.tab2-list3')}}</li>
          <li>{{ $t('platformTab.tab2-list4')}}</li>
          <li>{{ $t('platformTab.tab2-list5')}}</li>
          <router-link to="shortselling" class="learn-more">Learn more</router-link>
        </ul>
      </div>
    </div>
    <div class="tab-content" v-if="selectedTab === 'tab3'">
      <div class="image-container">
        <img src="@/assets/images/tab-image3.gif" alt="" />
      </div>
      <div class="feature-list">
        <ul>
          <li>{{$t('platformTab.tab3-list1')}}</li>
          <li>{{$t('platformTab.tab3-list2')}}</li>
          <li>{{$t('platformTab.tab3-list3')}}</li>
          <li>{{$t('platformTab.tab3-list4')}}</li>
          <li>{{$t('platformTab.tab3-list5')}}</li>
          <li>{{$t('platformTab.tab3-list6')}}</li>
          <router-link to="autotrading" class="learn-more">Learn more</router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlatformTab',

  data() {
    return {
      selectedTab: 'tab1',
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.tab-container {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
  @media (max-width: $mobile) {
    margin-top: 40px;
    gap: 10px;
  }
}
.tab {
  text-align: center;
  background-color: white;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 1 380px;
  cursor: pointer;
  &.active {
    background-color: var(--main-orange);
    color: white;
    p {
      opacity: 1;
    }
  }
  /* width: 100%; */
  p {
    font-size: 18px;
    font-weight: bold;
    line-height: 1.3em;
    opacity: 0.6;
    padding-bottom: 2px;
    br {
      display: none;
    }
    @media (max-width: $mobile) {
      font-size: 15px;
      br {
        display: block;
      }
    }
  }
}
.tab-content {
  display: flex;
  margin-top: 40px;
  .image-container {
    flex: 0 1 660px;
    img {
      width: 100%;
    }
  }
  @media (max-width: $mobile) {
    flex-direction: column;
    margin-top: 20px;
    .image-container {
      flex: 1;
    }
  }
  .feature-list {
    height: 360px;
    background-color: white;
    flex: 1;
    display: flex;
    align-items: center;
    padding-left: 50px;
    @media (max-width: $mobile) {
      padding: 0 20px;
      display: block;
    }
    ul {
      opacity: 0.8;
      margin-bottom: 24px;
      @media (max-width: $mobile) {
        margin-top: 40px;
        margin-bottom: 40px;
      }
      li {
        position: relative;
        font-size: 16px;
        font-weight: bold;
        padding-left: 12px;
        &:not(:last-child) {
          margin-bottom: 16px;
        }
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0;
          width: 3px;
          height: 3px;
          background-color: black;
          border-radius: 50vh;
        }
        @media (max-width: $mobile) {
          font-size: 14px;
        }
      }
    }
    .learn-more {
      color: var(--main-orange);
      font-size: 16px;
      font-weight: bold;
      @media (max-width: $mobile) {
        font-size: 14px;
      }
    }
  }
}
</style>
